import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'epochToLongDate'
})
export class ConvertEpochToLongDate implements PipeTransform {
  transform(value: string): string {
    const datePipe = new DatePipe('en-US');
    let epochDateVal = value.replace(/[^0-9]/g, '');
    epochDateVal = datePipe.transform(epochDateVal, 'EEEE d MMMM y h:mm a') ?? '';
    return epochDateVal;
  }
}
